// @ts-strict-ignore
import { ShopInfoQuery, useShopInfoQuery } from "@dashboard/graphql";
import { createContext, ReactNode } from "react";

type ShopContext = ShopInfoQuery["shop"];

export const ShopContext = createContext<ShopContext>(undefined);

export const ShopProvider = ({ children }: { children: ReactNode }) => {
  const { data } = useShopInfoQuery({
    displayLoader: true,
  });

  return (
    <ShopContext.Provider value={data?.shop ? data.shop : undefined}>
      {children}
    </ShopContext.Provider>
  );
};
